import { Stack, useTheme } from "@mui/material";
import { User } from "lucide-react";
import { useClientQuery } from "web_myplann/Api/Client/useClientQuery";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DataCard } from "web_myplann/Shared/Components/DataCard";
import { DataRow } from "web_myplann/Shared/Components/DataRow";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import { dateFormatter } from "web_myplann/Shared/Utils/formatters";

export const PersonalDataAndAccountsPage = () => {
	const theme = useTheme();
	const { t } = useResource();

	const { data: userData } = useClientQuery();

	return (
		<MyPlannLayout
			disableContentPadding
			topBar={
				<NavigationHeader
					title={t(Resources.PersonalDataAndAccounts.title)}
					defaultRoute={Routing.Dashboard.path()}
				/>
			}
		>
			<Stack p={1.6}>
				<DataCard
					icon={<User color={theme.palette.grey[700]} />}
					label={t(Resources.PersonalDataAndAccounts.PersonalData.title)}
					noDivider
				>
					<DataRow
						label={t(Resources.PersonalDataAndAccounts.PersonalData.Name)}
						value={userData?.data?.firstName}
					/>
					<DataRow
						label={t(Resources.PersonalDataAndAccounts.PersonalData.Surname)}
						value={userData?.data?.lastName}
					/>
					<DataRow
						label={t(
							Resources.PersonalDataAndAccounts.PersonalData.BirthNumber,
						)}
						value={userData?.data?.identificationNumber}
					/>
					<DataRow
						label={t(Resources.PersonalDataAndAccounts.PersonalData.BirthDate)}
						value={dateFormatter(userData?.data?.bornDate)}
					/>
					<DataRow
						label={t(Resources.PersonalDataAndAccounts.PersonalData.BirthPlace)}
						value={userData?.data?.bornPlace}
					/>
					<DataRow
						label={t(
							Resources.PersonalDataAndAccounts.PersonalData.MaritalStatus,
						)}
						value={userData?.data?.maritalStatus}
					/>
					<DataRow
						label={t(
							Resources.PersonalDataAndAccounts.PersonalData.HealthInsurance,
						)}
						value={userData?.data?.healthInsurance}
					/>
				</DataCard>
			</Stack>
		</MyPlannLayout>
	);
};
